import React from 'react';

import {
  Labeled,
  maxValue,
  minValue,
  NumberInput,
  required,
  TextInput,
} from 'react-admin';

import {
  Grid,
} from '@mui/material';

import CreateDialog from '../layout/dialog/CreateDialog';

const RiskClassCreate = () => (
  <CreateDialog title="risk class">
    <Grid container spacing={6}>
      <Grid size={12}>
        <Labeled label="Name">
          <TextInput validate={required()} source="name" label="" helperText={false} />
        </Labeled>
      </Grid>
      <Grid size={12}>
        <Labeled label="Minimum score (%)">
          <NumberInput validate={[required(), maxValue(99), minValue(0)]} source="min" label="" helperText={false} />
        </Labeled>
      </Grid>
      <Grid size={12}>
        <Labeled label="Maximum score (%)">
          <NumberInput validate={[required(), maxValue(100), minValue(1)]} source="max" label="" helperText={false} />
        </Labeled>
      </Grid>
    </Grid>
  </CreateDialog>
);

export default RiskClassCreate;
